import { z } from 'zod';
export const idSchema = z.number().int().positive();
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Esperado YYYY-MM-DD');
export const isoTimeSchema = z.string().regex(/^\d{2}:\d{2}$/, 'Esperado HH:MM');
export const isoDateTimeSchema = z.string().datetime({ offset: true });
export const hexColorSchema = z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Esperado #RRGGBB');
//# sourceMappingURL=common.js.map